import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@whatslly/ui-components/Tooltip";
import styles from "@whatslly/instant-messaging/react-app/status-bar/components/StatusBar/status-bar.module.scss";
import classnames from "classnames";
import { Svg } from "@whatslly/ui-components/v2/BaseElements/Svg";
import type { ItemType } from "../statusBarUtils";
import { updateItemAndHandleError } from "../statusBarUtils";
export const DotsMenu: React.FC<{
  setCurrentItemValue: (newValue: string) => void;
  items?: ItemType[];
  currentBarItemIndex?: number;
  parentItemId: string | undefined;
  isSaving: boolean;
  setSaving: (val: boolean) => void;
  parentItemType: "Opportunity" | "Lead";
}> = ({ setCurrentItemValue, currentBarItemIndex, items, parentItemId, isSaving, setSaving, parentItemType }) => {
  const { t } = useTranslation();

  const isLastItemSelected = useMemo(() => items && currentBarItemIndex === items.length - 1, [items, currentBarItemIndex]);

  const isLastItemClosed = useMemo(
    () => items && currentBarItemIndex && isLastItemSelected && items[currentBarItemIndex].IsClosed,
    [items, currentBarItemIndex, isLastItemSelected]
  );

  const selectNextStage = useCallback(async () => {
    if (typeof currentBarItemIndex === "undefined" || !items) {
      return;
    }
    const prevItem = items[currentBarItemIndex];
    const item = items[currentBarItemIndex + 1];
    if (isLastItemSelected && parentItemId) {
      setSaving(true);
      updateItemAndHandleError(prevItem, prevItem, parentItemId, setCurrentItemValue, parentItemType);
      return;
    }
    if (!item || !item.tvsAction || !parentItemId) {
      return;
    }
    setSaving(true);
    updateItemAndHandleError(item, prevItem, parentItemId, setCurrentItemValue, parentItemType);
  }, [items, parentItemId, currentBarItemIndex, setCurrentItemValue, isLastItemSelected, parentItemType]);

  if (!items) {
    return <></>;
  }

  return (
    <Tooltip
      className={styles.subMenuTooltip}
      trigger="click"
      placement="bottom-right"
      value={
        <div className={classnames(styles.subMenuContainer, { [styles.disabled]: isSaving })} onClick={selectNextStage}>
          <div className={styles.subMenuWrapper}>
            <Svg iconName={"v-icon-circle"} />
            {isLastItemClosed ? t("change_closed_stage") : t("mark_stage_as_completed")}
          </div>
        </div>
      }
    >
      <Svg className={styles.menuIcon} iconName={"dots-menu"} />
    </Tooltip>
  );
};
